import { useOpsSearchTool } from 'app/components/ops-search-tool/useOpsSearchTool'
import { OpsSearchToolComponent } from 'app/components/ops-search-tool/OpsSearchToolComponent'

export default function SearchTool(): React.ReactElement {
  const hookData = useOpsSearchTool()
  return <OpsSearchToolComponent {...hookData} />
}
